// extracted by mini-css-extract-plugin
export default {"root":"LargeModal_root__QqOte"};